import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Root from './Root'; // Import the Root component
import reportWebVitals from './reportWebVitals';
// GA initialization moved to App.js and CookiePopup.js to respect cookie consent

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root /> {/* Render the Root component which includes Router and App */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();